import styled from "styled-components";
import StepLabel from "@mui/material/StepLabel";

import { breakpoints } from "@/styles/breakpoints";

export const StyledStepperContainer = styled.div`
    .stepper-root {
        padding: 0;
        background-color: transparent;
    }

    .stepper-horizontal {
        box-sizing: border-box;
        display: inline-flex;
        justify-content: space-between;
        width: 100%;
        padding: 18px;
        max-width: 50rem;
        background-color: transparent;
        border: 1px solid var(--color-grey-700);
        border-radius: var(--radius-5);
        @media ${breakpoints.sm} {
            justify-content: space-evenly;
        }
        @media ${breakpoints.xs} {
            padding-right: 0;
            padding-left: 0;
        }
    }

    .step-horizontal {
        align-self: baseline;
        padding-right: 0;
        padding-left: 0;
        text-align: -webkit-auto;
        word-break: break-word;

        @media ${breakpoints.xs} {
            padding-right: 8px;
            padding-left: 8px;
        }

        .steplabel-label {
            margin-left: 8px;
            @media ${breakpoints.xs} {
                display: none;
            }
        }
    }
`;

export const StyledStepperTitle = styled.p`
    margin-top: 0;
    font-size: var(--size-24);
    font-style: normal;
    color: var(--color-white);
    text-align: left;
    @media ${breakpoints.sm} {
        font-size: var(--size-18);
        text-align: center;
    }
`;

export const StyledBar = styled.div<{ $active: boolean }>`
    width: 0;
    height: 64px;
    @media ${breakpoints.sm} {
        width: 64px;
        height: 0;
        margin-top: ${(props) => (props.$active ? "0" : "-4")}px;
    }
    @media ${breakpoints.xs} {
        width: 40px;
    }

    background-color: var(--color-grey-700);
    border: 2px solid ${(props) => (props.$active ? "var(--color-secondary)" : "var(--color-grey-700)")};
    border-radius: var(--radius-10);
`;

export const StyledCircle = styled.div`
    width: 0;
    height: 0;
    margin-top: 6px;
    margin-bottom: 6px;
    border: 2px solid var(--color-grey-700);
    border-radius: var(--radius-10);
    @media ${breakpoints.sm} {
        margin-top: 0;
        margin-bottom: 0;
        margin-left: -2px;
    }
`;
export const StyledSteplabel = styled(StepLabel)<{ $active: boolean }>`
    .steplabel-label {
        font-size: var(--size-14);
        font-style: normal;
        font-weight: ${(props) => (props.$active ? "bold !important" : 600)};
        line-height: 19px;
        color: ${(props) => (props.$active ? "var(--color-secondary)" : "var(--color-white)")};
        text-transform: uppercase;
        @media ${breakpoints.xs} {
            font-size: var(--size-10);
            line-height: 15px;
        }
    }
`;
